import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    color: theme.palette.text.hint,
    height: '100%',

    '& .load-more': {
      color: theme.palette.text.hint,
    },

    '& .comments': {
      '&-message': {
        padding: theme.spacing(3, 0),
      },
      '&-button-retry': {
        display: 'inline-flex',
        margin: `0 auto ${theme.spacing(3)}px`,
      },
      '&-loading-container': {
        padding: theme.spacing(3),
      },
      '&-list-container': {
        flexGrow: 1,
        width: '100%',
        height: '100%',
        paddingTop: theme.spacing(3),

        '& .list-top-spacing': {
          height: theme.spacing(3),
          display: 'flex',
          width: '100%',
        },

        [theme.breakpoints.up('md')]: {
          ...theme.globalStyles.scrollbar(theme),
        },
      },
    },
  },

  list: {
    flexGrow: 1,
    width: '100%',

    [theme.breakpoints.up('md')]: {
      ...theme.globalStyles.scrollbar(theme),
    },
  },

  emptyListBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
  },

  filledListBox: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

export default styles;
